import { Routes, UrlMatchResult, UrlSegment } from '@angular/router'
import { authGuard } from './services/auth-guard'
import { mergeLogsGuard } from './services/merge-logs-guard'
import { restaurantFeatureGuard } from './services/restaurant-feature-guard'

/**
 * Matches both `emails` and `emails/:messageId` as one route, so the page is kept
 * rather than built anew when the first email type is picked and its id joins the url.
 */
export function emailsMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length === 0 || segments.length > 2) {
    return null
  }
  if (segments[0].path !== 'emails') {
    return null
  }
  return {
    consumed: segments,
    posParams: segments.length === 2 ? { messageId: segments[1] } : {},
  }
}

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'customers',
    loadComponent: () =>
      import('./customers/customers.component').then(
        (m) => m.CustomersComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'customers/merge',
    loadComponent: () =>
      import('./data-merge/customers-merge/customers-data-merge.component').then(
        (m) => m.CustomersDataMergeComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'customers/merge-logs',
    loadComponent: () =>
      import('./merge-logs/merge-logs.component').then(
        (m) => m.MergeLogsComponent,
      ),
    canActivate: [mergeLogsGuard],
  },
  {
    path: 'sources',
    loadComponent: () =>
      import('./customer-sources/customer-sources.component').then(
        (m) => m.SourcesComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'sources/merge',
    loadComponent: () =>
      import('./data-merge/sources-merge/sources-data-merge.component').then(
        (m) => m.CustomerSourcesDataMergeComponent,
      ),
    canActivate: [authGuard],
  },
  {
    matcher: emailsMatcher,
    loadComponent: () =>
      import('./emails/emails.component').then((m) => m.EmailsComponent),
    canActivate: [restaurantFeatureGuard('emails')],
  },
  {
    path: 'campaigns',
    loadComponent: () =>
      import('./campaigns/campaigns.component').then(
        (m) => m.CampaignsComponent,
      ),
    canActivate: [restaurantFeatureGuard('campaigns')],
  },
  {
    path: 'campaigns/:id/recipients',
    loadComponent: () =>
      import('./campaigns/campaign-recipients/campaign-recipients.component').then(
        (m) => m.CampaignRecipientsComponent,
      ),
    canActivate: [restaurantFeatureGuard('campaigns')],
  },
  {
    path: 'info',
    loadComponent: () =>
      import('./info/info.component').then((m) => m.InfoComponent),
  },
  {
    path: '*',
    redirectTo: '/',
    pathMatch: 'full',
  },
]
